import { daemonServiceLaneSchema } from "../daemon/service-contract.js";
import { daemonExecutionCompatibilitySchema, localWakeRouteReportSchema, runtimeTransportCapabilitiesSchema, runtimeTransportErrorCodeSchema, runtimeTransportLookupRouteOwnerServiceEvidenceSchema, runtimeTransportRejectedProfileRegistrationSchema } from "../daemon/runtime-transport.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/daemon-route-observation.ts
const daemonRouteObservationRouteSchema = z$1.discriminatedUnion("online", [z$1.strictObject({
	online: z$1.literal(true),
	daemonSessionId: z$1.string().min(1),
	deviceId: z$1.string().min(1),
	lane: daemonServiceLaneSchema,
	serviceVersion: z$1.string().trim().min(1).nullable().optional(),
	connectionGeneration: z$1.number().int().positive(),
	leaseEpoch: z$1.number().int().positive(),
	lastHeartbeatMs: z$1.number().int().nonnegative(),
	capabilities: runtimeTransportCapabilitiesSchema,
	executionCompatibility: daemonExecutionCompatibilitySchema,
	localWakeRouteReport: localWakeRouteReportSchema.optional()
}), z$1.strictObject({
	online: z$1.literal(false),
	reasonCode: runtimeTransportErrorCodeSchema,
	lastHeartbeatMs: z$1.number().int().nonnegative().optional(),
	ownerService: runtimeTransportLookupRouteOwnerServiceEvidenceSchema.optional(),
	executionCompatibility: daemonExecutionCompatibilitySchema.optional(),
	localWakeRouteReport: localWakeRouteReportSchema.optional(),
	rejectedProfileRegistration: runtimeTransportRejectedProfileRegistrationSchema.optional()
})]);
const daemonRouteObservationResponseSchema = z$1.strictObject({
	observedAt: z$1.string().trim().min(1),
	profileId: z$1.string().trim().min(1),
	route: daemonRouteObservationRouteSchema
});
//#endregion
export { daemonRouteObservationResponseSchema, daemonRouteObservationRouteSchema };

//# sourceMappingURL=daemon-route-observation.js.map